import { AdminLayoutWithAuth } from "@/components/layout/AdminLayout/AdminLayout";
import AuthCallback from "@/pages/auth/AuthCallback";
import Login from "@/pages/auth/Login";
import Logout from "@/pages/auth/Logout";
import PageNotFound from "@/pages/PageNotFound";
import ServerErrorPage from "@/pages/ServerErrorPage";
import Home from "@/pages/home/Home";
import OrganizationList from "@/pages/organization/OrganizationList";
import OrganizationCreate from "@/pages/organization/OrganizationCreate";
import OrganizationDetail from "@/pages/organization/OrganizationDetail";
import OrganizationEdit from "@/pages/organization/OrganizationEdit";
import MasterDataList from "@/pages/master-data/MasterDataList";
import MasterDataDetail from "@/pages/master-data/MasterDataDetail";
import Information from "@/pages/information/Information";
import InformationCreate from "@/pages/information/InformationCreate";
import InformationEdit from "@/pages/information/InformationEdit";
import EmailSetting from "@/pages/system-setting/EmailSetting";
import MaintenanceSetting from "@/pages/system-setting/MaintenanceSetting";
import { SettingLayout } from "@/features/system-setting/layout/SettingLayout";
import { AppRoutes } from "@/routes/config";
import { RouteObject } from "react-router-dom";

export const routes: RouteObject[] = [
  {
    element: <AdminLayoutWithAuth />,
    children: [
      {
        path: AppRoutes.home,
        element: <Home />,
      },
      { path: AppRoutes.organizationList, element: <OrganizationList /> },
      { path: AppRoutes.organizationCreate, element: <OrganizationCreate /> },
      { path: AppRoutes.organizationDetail, element: <OrganizationDetail /> },
      { path: AppRoutes.organizationEdit, element: <OrganizationEdit /> },
      { path: AppRoutes.masterData, element: <MasterDataList /> },
      { path: AppRoutes.masterDataDetail, element: <MasterDataDetail /> },
      { path: AppRoutes.information, element: <Information /> },
      { path: AppRoutes.informationCreate, element: <InformationCreate /> },
      { path: AppRoutes.informationEdit, element: <InformationEdit /> },
      {
        element: <SettingLayout />,
        children: [
          { path: AppRoutes.emailSetting, element: <EmailSetting /> },
          { path: AppRoutes.maintenanceSetting, element: <MaintenanceSetting /> },
        ],
      },
    ],
  },
  { path: AppRoutes.login, element: <Login /> },
  { path: AppRoutes.authCallback, element: <AuthCallback /> },
  { path: AppRoutes.logout, element: <Logout /> },
  { path: AppRoutes.serverErrorPage, element: <ServerErrorPage /> },
  { path: "*", element: <PageNotFound /> },
];
